@import "../../../../shared/scss";

:host {
  display: block;
}

.drawer-header {
  block-size: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  phn-nd-signature-heading {
    inline-size: 100%;
    text-align: center;
    padding-block-start: 18px;
  }
}

.heading-items {
  align-items: center;
}

.skeleton-headline {
  inline-size: p-px-to-rem(150px);
  block-size: p-px-to-rem(24px);
  background: $pds-theme-light-contrast-low;
  border-radius: 4px;
}

.button-skeleton {
  margin-inline-start: p-px-to-rem(8px);
  border-radius: p-px-to-rem(4px);
  block-size: p-px-to-rem(24px);
  inline-size: p-px-to-rem(24px);
  background: $pds-theme-light-contrast-low;
}
